import { render, staticRenderFns } from "./virtualStrategyBatchConfig.vue?vue&type=template&id=7ded31cd&"
import script from "./virtualStrategyBatchConfig.vue?vue&type=script&lang=js&"
export * from "./virtualStrategyBatchConfig.vue?vue&type=script&lang=js&"
import style0 from "./virtualStrategyBatchConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports